import { BaseService } from "../../core/baseService";
import {
  HousekeepingServiceInterface,
  UpdateRoomStatusParams,
  UpdateFloorStatusParams,
  BulkUpdateRoomStatusParams,
  BulkUpdateRoomStatusResponse,
} from "../types/room.types";
import { RoomDto } from "../../../models";

export class HousekeepingService
  extends BaseService
  implements HousekeepingServiceInterface
{
  async getRoomStatuses() {
    return this.handleRequest<RoomDto[]>(
      this.client.get("/api/admin/housekeeping/room-statuses"),
    );
  }

  async updateRoomStatus(params: UpdateRoomStatusParams) {
    const { roomId, newStatus } = params;

    return this.handleRequest<RoomDto>(
      this.client.put(`/api/admin/housekeeping/rooms/${roomId}/status`, {
        NewStatus: newStatus,
      }),
    );
  }

  async updateFloorStatus(params: UpdateFloorStatusParams) {
    const { floor, newStatus } = params;

    return this.handleRequest<RoomDto[]>(
      this.client.put(`/api/admin/housekeeping/floors/${floor}/status`, {
        NewStatus: newStatus,
      }),
    );
  }

  async bulkUpdateRoomStatus(params: BulkUpdateRoomStatusParams) {
    const { roomIds, newStatus } = params;

    return this.handleRequest<BulkUpdateRoomStatusResponse>(
      this.client.put("/api/admin/housekeeping/rooms/bulk-status", {
        RoomIds: roomIds,
        NewStatus: newStatus,
      }),
    );
  }
}
